import React from "react";
import styled from "styled-components";
import { useLoadingStore } from "../../Store/store";

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.622);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  gap: 10px;

  .loading-spinner {
    width: 100px;
    height: 100px;
    border: 10px solid #252525;
    border-top: 10px solid #4ade80;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 600px) {
    font-size: 16px;
    gap: 15px;

    .loading-spinner {
      width: 80px;
      height: 80px;
      border: 8px solid #252525;
      border-top: 8px solid #4ade80;
    }
  }
`;
export default function Loading() {
  const { isLoading, loadingText, hideLoading } = useLoadingStore();
  return (
    <LoadingContainer>
      <div className="loading-spinner"></div>
      <span>{loadingText}</span>
    </LoadingContainer>
  );
}
